export default {
  mobileTiles: [
    {
      company: 'Inc',
      height: '151px',
      width: '240px',
      centered: true,
      naturalHeight: 100,
      naturalWidth: 152,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/2022_Inc_BestWorkplaces_Logo.png',
      customTileStyle: 'press-logo-columns-5 wide',
    },
    {
      company: 'Fortune Best Financial Services 2022',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/Fortune-2022-Financial-Services.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fortune Best Women',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/Fortune-2022-GPTW-Women.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: "Fortune's Best Workplaces in the Bay Area 2023",
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/GPTW_Bay%20Area-web.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: "Fortune's Best Workplaces for Millennials 2023",
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/GPTW_Millennials-web.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'MLT',
      height: '131px',
      width: '109px',
      naturalHeight: 131,
      naturalWidth: 109,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/MLT-logo-2023.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fair Pay Workplace',
      height: '141px',
      width: '95px',
      naturalHeight: 141,
      naturalWidth: 95,
      image:
        'https://www.nerdwallet.com/cdn/company/images/2022/Fair-pay-workplace.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Real Simple',
      height: '110px',
      width: '110px',
      naturalHeight: 110,
      naturalWidth: 110,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/real-simple-smart-money.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
  topTiles: [
    {
      company: 'Inc',
      height: '192px',
      width: '240px',
      centered: true,
      naturalHeight: 122,
      naturalWidth: 152,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/2022_Inc_BestWorkplaces_Logo-desktop.png',
      customTileStyle: 'press-logo-columns-5 wide',
    },
    {
      company: 'Fortune Best Financial Services 2022',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/Fortune-2022-Financial-Services.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fortune Best Women',
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/Fortune-2022-GPTW-Women.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: "Fortune's Best Workplaces in the Bay Area 2023",
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/GPTW_Bay%20Area-web.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
  bottomTiles: [
    {
      company: "Fortune's Best Workplaces for Millennials 2023",
      height: '151px',
      width: '96px',
      naturalHeight: 151,
      naturalWidth: 96,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/GPTW_Millennials-web.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'MLT',
      height: '131px',
      width: '109px',
      naturalHeight: 131,
      naturalWidth: 109,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/MLT-logo-2023.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fair Pay Workplace',
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image:
        'https://www.nerdwallet.com/cdn/company/images/2022/Fair-pay-workplace.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Real Simple',
      height: '110px',
      width: '110px',
      naturalHeight: 110,
      naturalWidth: 110,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/real-simple-smart-money.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
};
